import { FC } from 'react';
import {
  IMappedGroupSchedule,
  IMappedScheduleDateData,
  IMappedTeacherSchedule,
} from 'entities/types';

import { makeLesson } from '../lib';

import styles from './styles.module.scss';

interface IRowTimelineSchedule {
  data: IMappedGroupSchedule[] | IMappedTeacherSchedule[];
  dateData: IMappedScheduleDateData;
}

export const RowTimelineSchedule: FC<IRowTimelineSchedule> = ({
  data,
  dateData,
}) => {
  return (
    <div className={styles['row-schedule']}>
      <div className={styles['row-schedule__date-card']}>
        <div className={styles['row-schedule__date']}>
          {dateData.date}
          <span className={styles['row-schedule__sum']}> — {data.length}</span>
        </div>
        <div className={styles['row-schedule__parity-type']}>
          {dateData.weekParity}
        </div>
        {dateData.isPrimary && (
          <div className={styles['row-schedule__today']}>Сегодня</div>
        )}
      </div>

      <div className={styles['row-schedule__lessons-container']}>
        {makeLesson(data)}
      </div>
    </div>
  );
};
